import React from 'react';
import styles from '../MailTemplateSent.module.scss';
import USerProfileIcon from '../../../../../assets/Imagess/usreprofileicon.svg';
import moment from 'moment';
import { imageSrc } from '../../send-email/models/function';
import LinkedUsers from './linked-users/LinkedUsers';

const MailContent = ({ mailById, refetch, setRefresh }) => {
  const cc = mailById?.dto?.ccRecipients;
  // const to = mailById?.toList ? JSON.parse(mailById?.toList) : [];

  let html = mailById?.dto?.bodyContent;
  const attachments = mailById?.dto?.attachments || [];

  attachments.forEach((att) => {
    if (att.isInline && att.contentId && att.contentBytes) {
      const imgSrc = `data:${att.contentType};base64,${att.contentBytes}`;
      html = html.replaceAll(`cid:${att.contentId}`, imgSrc);
    }
  });

  return (
    <div className={styles['mailContent']}>
      <div className={styles.contentHeader}>
        {' '}
        <div className={styles['image_container']}>
          <img
            src={USerProfileIcon}
            alt='user'
            className={styles.userProfile}
          />
          <div className={`${styles['title']}`}>
            <p>{mailById?.dto?.subject || '(no subject)'}</p>
            <div className={styles.fromContainer}>
              {' '}
              <div className={styles.from}>
                <p>
                  from: <span>{mailById?.dto?.from?.address}</span>
                </p>

                <p>
                  To:{' '}
                  <span>
                    {mailById.dto.toRecipients.map((t) => t.address).join(', ')}
                  </span>
                </p>
              </div>{' '}
              {cc && cc.length > 0 && (
                <p>
                  cc: <span>{cc.map((c) => c.address).join(', ')}</span>
                </p>
              )}
            </div>
          </div>
        </div>
        <div className={styles.dateWrapper}>
          {' '}
          <p className={styles.date}>
            {moment(mailById.dto?.receivedDateTime).format(
              'MMM D, YYYY h:mm a',
            )}
          </p>
          {mailById?.linkedUsers?.length > 0 && (
            <LinkedUsers
              users={mailById?.linkedUsers}
              refetch={refetch}
              setRefresh={setRefresh}
            />
          )}
        </div>
      </div>
      <p dangerouslySetInnerHTML={{ __html: mailById?.dto?.bodyContent }} />

      {mailById?.dto?.attachments.length > 0 ? (
        <div className={styles.attachments_container}>
          <div className={styles.attachments_header}>Attachment</div>
          <div className={styles.attachments_list}>
            {mailById?.dto?.attachments?.length > 0 &&
            mailById?.dto?.attachments?.some((i) => i.isInline == false) ? (
              mailById?.dto?.attachments.map((file, index) => {
                if (file.isInline) return null;

                const fileType =
                  file?.contentType?.split('/').pop() ||
                  file?.name?.split('.').pop();

                const handleViewAttachment = () => {
                  console.log('fvdvfdvdfv');
                  if (file?.contentBytesBase64 && file?.contentType) {
                    const byteCharacters = atob(file.contentBytesBase64);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                      byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], {
                      type: file.contentType,
                    });
                    const blobURL = URL.createObjectURL(blob);
                    const newTab = window.open(blobURL, '_blank');
                    if (newTab) newTab.focus();
                  }
                };

                const handleDownloadAttachment = () => {
                  if (file?.contentBytesBase64 && file?.contentType) {
                    const fileURL = `data:${file.contentType};base64,${file.contentBytesBase64}`;
                    const link = document.createElement('a');
                    link.href = fileURL;
                    link.download = file.name || 'attachment';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }
                };

                return (
                  <div key={index} className={styles.fileItem}>
                    <img
                      src={imageSrc(fileType)}
                      className={styles.image}
                      alt='file'
                    />
                    <div className={styles.fileTitle}>
                      {`${file.name.slice(0, 25)}... `}
                      <span>({(file.size / 1024).toFixed(1)} KB)</span>

                      <div className={styles.actions}>
                        <p
                          onClick={handleViewAttachment}
                          className={styles.view}
                        >
                          View
                        </p>
                        <p
                          onClick={handleDownloadAttachment}
                          className={styles.download}
                        >
                          Download
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <p>No attachments</p>
            )}
          </div>
        </div>
      ) : (
        <p>No attachments</p>
      )}
    </div>
  );
};

export default MailContent;
